"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

require("./index.less");

function Grid(props) {
  var classNames = ["container"];

  if (props.className) {
    classNames.push(props.className);
  }

  return React.createElement("div", {
    style: props.style || {},
    className: classNames.join(" ")
  }, props.children);
}

exports.Grid = Grid;
;

function Row(props) {
  var classNames = ["row"];

  if (props.collapsed) {
    classNames.push("collapsed");
  }

  if (props.className) {
    classNames.push(props.className);
  }

  return React.createElement("div", {
    style: props.style || {},
    className: classNames.join(" ")
  }, props.children);
}

exports.Row = Row;
;

function Col(props) {
  var classNames = [];
  Object.keys(props).forEach(function (key) {
    var value = props[key];

    switch (key) {
      case "xs":
      case "sm":
      case "md":
      case "lg":
        classNames.push("col-" + key + "-" + value);
        break;

      case "xsOffset":
      case "smOffset":
      case "mdOffset":
      case "lgOffset":
        var media = key.substring(0, 2);
        classNames.push("col-" + media + "-offset-" + value);
        break;

      case "className":
        classNames.push(props.className);
        break;
    }
  });
  return React.createElement("div", {
    style: props.style || {},
    className: classNames.join(" ")
  }, props.children);
}

exports.Col = Col;